import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { TagValues } from '../../tags'

interface TagsProps {
  tags: string[]
}

const Tags = ({ tags }: TagsProps) => (
  <TagWrapper>
    {tags.map((tag, index) => {
      return (
        <Link to={`/${tag}`} className="tag" key={index}>
          {TagValues[tag]}
        </Link>
      )
    })}
  </TagWrapper>
)

export default Tags

const TagWrapper = styled.div`
  display: flex;
  margin-top: 2rem;
  .tag {
    background: ${p => p.theme.colors.gray[200]};
    color: ${p => p.theme.colors.gray[700]};
    border-radius: 4px;
    font-family: 'Barlow', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    padding: 4px 8px;
    letter-spacing: -0.02em;
    line-height: 16.38px;
    font-size: 14px;
    border-radius: 99px;
    margin-right: 8px;
    &:hover {
      background: ${p => p.theme.colors.gray[300]};
      color: ${p => p.theme.colors.gray[800]};
    }
  }
`